import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { auditTrailService } from 'services';

const initialState = {
  auditTrailsList: {},
  statusGetList: '',
  urlDownload: {},
  statusGetUrlDownload: '',
  dropDomainList: [],
  statusDropDomainListType: '',
  statusDetailAuditTrail:'',
  dataDetailAuditTrail:{},
};

export const getAuditTrailList = createAsyncThunk(
  'audit_trail/getAuditTrailList',
  async (data) => {
    const response = await auditTrailService.list(data);
    return response;
  },
);

export const getDetailAuditTrail = createAsyncThunk(
  'audit_trail/getDetailAuditTrail',
  async (data) => {
    const response = await auditTrailService.detail(data);
    return response;
  },
);

export const getAllDomainList = createAsyncThunk(
  'audit_trail/getAllDomainList',
  async () => {
    const response = await auditTrailService.domainList();
    return response;
  },
);

export const auditTrailSlice = createSlice({
  name: 'audit_trail',
  initialState: initialState,
  reducers: {
    resetData: (state, action) => {
      const payload = action.payload;
      if (typeof payload === 'string') {
        state[payload] = initialState[payload];
      } else if (Array.isArray(payload)) {
        payload.forEach((item) => (state[item] = initialState[item]));
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAuditTrailList.pending, (state) => {
        state.statusGetList = 'loading';
        state.auditTrailsList = {};
      })
      .addCase(getAuditTrailList.fulfilled, (state, action) => {
        state.statusGetList = 'success';
        state.auditTrailsList = action.payload;
      })
      .addCase(getAllDomainList.pending, (state) => {
        state.statusDropDomainListType = 'loading';
        state.dropDomainList = [];
      })
      .addCase(getAllDomainList.fulfilled, (state, action) => {
        state.statusDropDomainListType = 'success';
        state.dropDomainList = action.payload;
      })
      .addCase(getAllDomainList.rejected, (state) => {
        state.statusDropDomainListType = 'error';
        state.dropDomainList = [];
      })
      .addCase(getDetailAuditTrail.pending, (state) => {
        state.statusDetailAuditTrail = 'loading';
        state.dataDetailAuditTrail = {};
      })
      .addCase(getDetailAuditTrail.fulfilled, (state, action) => {
        state.statusDetailAuditTrail = 'success';
        state.dataDetailAuditTrail = action.payload;
      })
      .addCase(getDetailAuditTrail.rejected, (state) => {
        state.statusDetailAuditTrail = 'error';
        state.dataDetailAuditTrail = {};
      });
  },
});


export const { resetData } = auditTrailSlice.actions;

const auditTrailReducer = auditTrailSlice.reducer;
export default auditTrailReducer;